import axiosClient from "api/apiClient";

interface IOptions {
    page: string;
    sort?: string;
    order?: string;
    search?: string;
    type: string;
    export?: boolean;
    isArchived?: boolean;
}

export const APIGetUsers = (options: IOptions) => {
    let url = "";
    let sort = "";
    let search = "";
    let exportData = "";

    if(options.type === "students" && options.hasOwnProperty("isArchived") && options.isArchived) {
        url = "/students/archived";
    } else if (options.type === "teachers" && options.hasOwnProperty("isArchived") && options.isArchived) {
        url = "/teachers/archived";
    } else if (options.type === "students") {
        url = "/students";
    } else if (options.type === "teachers") {
        url = "/teachers";
    }

    if (options.hasOwnProperty("sort")) {
        if(options.order === "asc") {
            sort = "&sort=" + options.sort;
        } else if (options.order === "desc") {
            sort = "&sort=-" + options.sort;
        }
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.search;
    }

    if (options.hasOwnProperty("export")) {
        if (options.export) {
            exportData = "&export=true";
        }
    }

    if (options.hasOwnProperty("isArchived") && options.isArchived) {
        return axiosClient.post(`${url}${options.page}${search}${sort}${exportData}`);
    } else {
        return axiosClient.get(`${url}${options.page}${search}${sort}${exportData}`);
    }
};